import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import Datepicker from '@vuepic/vue-datepicker';
import router from './router';
import 'maz-ui/styles';
import '@vuepic/vue-datepicker/dist/main.css';
import { VueTruncateHtml } from 'vue3-truncate-html';
import LoadingComponent from '@/components/LoadingComponent.vue';
import InfoWindow from '@/components/InfoWindow.vue';
import PWS from '@/components/PayWithStripe.vue';
import LoadError from '@/components/LoadError.vue';
import { reportError } from '@/services/errors';

loadFonts().catch(reportError);

const app = createApp(App);
app.config.errorHandler = reportError;

app
  .use(vuetify)
  .use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyAcQuG_DTI6mIpkGCKPoldQPac6sllaIdY',
    },
  })
  .use(router)
  .component('Loading', LoadingComponent)
  .component('LoadError', LoadError)
  .component('Info', InfoWindow)
  .component('vue-truncate-html', VueTruncateHtml)
  .component('PWS', PWS)
  .component('Datepicker', Datepicker)
  .mount('#app');
